import React from 'react';
import { Button, Spinner, TagFeedback, TooltipTrigger } from '@spark';

const START_TOOLTIP =
    'This can take 15+ minutes, depending on available resources in your environment. The model will start automatically once resources are ready. The session auto-stops after 2 hours.';

/**
 * GPU session control for generative Playground (vLLM lifecycle).
 * Rendered in the top toolbar next to Run all on a generative task, even
 * before SpecificAI slots hydrate. Wraps `useSummarizationInference`.
 */
const SummarizationGpuControl = ({ inference }) => {
    const {
        status,
        isRunning,
        isStarting,
        isStopping,
        remainingMs,
        remainingLabel,
        start,
        stop,
        cancel,
    } = inference;
    const showCountdown = remainingMs > 0;

    if (isRunning) {
        const tooltip = showCountdown
            ? `Stop GPU (auto-stop in ${remainingLabel})`
            : 'Stop GPU (auto-stops after 2 hours)';
        return (
            <span className="pg-gpu-status">
                {showCountdown ? (
                    <TagFeedback label={remainingLabel} variant="processing" />
                ) : null}
                <TooltipTrigger text={tooltip} placement="bottom">
                    <span>
                        <Button
                            variant="tertiary"
                            size="small"
                            disabled={isStopping}
                            disableWhenReadOnly
                            onClick={stop}
                        >
                            Stop GPU
                        </Button>
                    </span>
                </TooltipTrigger>
            </span>
        );
    }

    if (isStarting) {
        return (
            <span className="pg-gpu-status">
                <Spinner size="small" />
                <TooltipTrigger
                    text="GPU is starting (cold start can take several minutes)"
                    placement="bottom"
                >
                    <span>Starting GPU…</span>
                </TooltipTrigger>
                <Button variant="tertiary" size="small" disableWhenReadOnly onClick={cancel}>
                    Cancel
                </Button>
            </span>
        );
    }

    return (
        <TooltipTrigger text={START_TOOLTIP} placement="bottom">
            <span>
                <Button
                    variant="secondary"
                    size="small"
                    disabled={status === 'stopping'}
                    disableWhenReadOnly
                    onClick={start}
                >
                    {status === 'error' ? 'Retry Start GPU' : 'Start GPU'}
                </Button>
            </span>
        </TooltipTrigger>
    );
};

export default SummarizationGpuControl;
